import React, { useLayoutEffect, useState } from "react";
import { Stack, styled } from "@mui/material";
import {
  Box,
  Button,
  Container,
  Dialog,
  Typography,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";

const RootStyle = styled("div")({
  width: "400px",
  height: "250px",
  padding: "50px 10px",
  background: "white",
  textAlign: "center",
  alignItems: "center",
});
const ButtonCancel = styled(Button)({
  backgroundColor: "rgb(138, 138, 138)",
  color: "white",
  margin: "15px",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
  "&:hover": {
    backgroundColor: "rgb(138, 138, 138)",
  },
});
const ButtonDelete = styled(Button)({
  backgroundColor: "red",
  color: "white",
  margin: "15px",
  borderRadius: "5px",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
  "&:hover": {
    backgroundColor: "red",
  },
});

function DeleteBill({ title, open, onClose, onClickCancel, onClickYes }) {
  const companyCode = localStorage.getItem("companyCode");
  const [state, setState] = useState({
    confirm: false,
    companyCode: "",
  });

  useLayoutEffect(() => {
    setState((prev) => ({ ...prev, confirm: false, companyCode: "" }));
  }, [open]);

  const handleChange = (e) => {
    const { value } = e.target;
    setState((prev) => ({ ...prev, companyCode: value }));
  };

  const handleConfirm = (e) => {
    setState((prev) => ({ ...prev, confirm: true }));
  };
  const handleDelete = () => {
    if (companyCode == state.companyCode) {
      onClickYes();
    } else {
      toast.configure();
      toast.info("Provide valid Company Code");
    }
  };
  return (
    <Box>
      <Dialog title={title} open={open} onClose={onClose}>
        <RootStyle>
          {state.confirm == false && (
            <Typography
              variant="h6"
              sx={{ fontSize: { md: "1.5rem", xs: "12px" } }}
            >
              Are you sure to want to Delete Bill
            </Typography>
          )}

          {state.confirm == false && (
            <Stack
              direction="row"
              justifyContent="space-evenly"
              gap={2}
              marginTop="50px"
            >
              <ButtonDelete
                sx={{
                  background: "#4EAF51",
                  "&:hover": {
                    backgroundColor: "#4EAF51",
                  },
                }}
                fullWidth
                onClick={handleConfirm}
              >
                Yes
              </ButtonDelete>
              <ButtonCancel fullWidth onClick={onClickCancel}>
                No
              </ButtonCancel>
            </Stack>
          )}
          {state.confirm && (
            <Stack justifyContent="center" alignItems="center">
              <Typography variant="h6" sx={{ color: "red", mb: "10px" }}>
                Enter Company Code to Delete
              </Typography>
              <TextField
                width="70%"
                variant="outlined"
                label="Company Code"
                name="companyCode"
                value={state.companyCode}
                onChange={handleChange}
              />
              {(!state.companyCode || state?.companyCode?.length < 4) && (
                <ButtonCancel width="70%" onClick={onClickCancel}>
                  Cancel
                </ButtonCancel>
              )}
            </Stack>
          )}
          {state.companyCode && state.companyCode.length > 0 && (
            <Stack
              direction="row"
              justifyContent="space-evenly"
              gap={2}
              margin="0px 20px"
            >
              <ButtonDelete fullWidth onClick={handleDelete}>
                Delete
              </ButtonDelete>
              <ButtonCancel fullWidth onClick={onClickCancel}>
                Cancel
              </ButtonCancel>
            </Stack>
          )}
        </RootStyle>
      </Dialog>
    </Box>
  );
}

export default DeleteBill;
